import { IPanelProps, Panel } from '@fluentui/react';
import * as React from 'react';
import ConfirmDialog from './ConfirmDialog';

export interface IConfirmablePanelProps extends IPanelProps {
    onDismiss: () => void;
}

const ConfirmablePanel: React.FunctionComponent<IConfirmablePanelProps> = (props: React.PropsWithChildren<IConfirmablePanelProps>) => {
    const [isConfirmOpen, setIsConfirmOpen] = React.useState(false);

    return (
        <>
            <Panel {...props} onDismiss={(ev?: React.SyntheticEvent<HTMLElement> | KeyboardEvent) => { if ((ev as any).keyCode !== 27) setIsConfirmOpen(true) }} />
            <ConfirmDialog
                isOpen={isConfirmOpen}
                title='Advarsel'
                subText='Du er på vej til at lukke uden at gemme. Vil du fortsætte?'
                onConfirm={() => { setIsConfirmOpen(false); props.onDismiss(); }}
                onCancel={() => setIsConfirmOpen(false)}
            />
        </>
    );
}

export default ConfirmablePanel;